module.exports = __webpack_public_path__ + "img/xs.c11be81b.jpg";